(function () {
    const myObj = {
        resolver: null,
        submitted: false
    };

    myObj.checker = function () {
        if (typeof window.$$epiforms == "undefined") {
            window.requestAnimationFrame(this.checker);
        } else {
            this.resolver("ready");
        }
    }

    myObj.resolveAfterLoad = function () {
        return new Promise(resolve => {
            this.resolver = resolve;
            window.requestAnimationFrame(this.checker);
        });
    }

    myObj.init = function () {
        console.log("Ending $$epiforms Check ", typeof window.$$epiforms);

        myObj.setEvent();
    }

    myObj.setUtagMultistep = function (formName, currentStep, stepcount) {
        if (window.utag !== null && window.utag !== undefined) {
            const stepNumber = currentStep + "-of-" + stepcount;
            window.utag.view({
                event_name: "form-virtual-step",
                content_type: "form-step-" + stepNumber,
                url_override: window.location.href + "?form_step=" + stepNumber,
                form_name: formName
            });
        }
    }

    myObj.setEvent = function() {

        $$epiforms(document).ready(function myfunction() {
            $$epiforms(".EPiServerForms").each(function (i, f) {

                $$epiforms(f).find("[data-f-type=submitbutton]").on("click", function () {
                    myObj.submitted = true;

                    $(this).prop("disabled", true);
                });

                $$epiforms(f).on("formsSubmitted", function () {
                    $$epiforms(f).addClass("formsSubmittedCustomClass");
                    zaius.event('FormSubmission', {action: $$epiforms(f).find(".Form__MainBody").data("taxonFormTitle")});
                });

                var optInStatusLive = $$epiforms(f).find('#optInStatusLive').length;

                const setHandlerByType = function(element, handlerElement) {
                    if (element.dataset.fType === 'choice') {
                        $(element).find('input').on('change',
                            function() {
                                setHandlerValidation(handlerElement);
                            });
                    } else if (element.dataset.fType === 'selection') {
                        $(element).find('select').on('change',
                            function() {
                                setHandlerValidation(handlerElement);
                            });
                        $(element).on('focusout',
                            function() {
                                setHandlerValidation(handlerElement);
                            });
                    } else if (element.dataset.fType === 'fileupload') {
                        ; // nothing here
                    } else {
                        $(element).on('focusout',
                            function() {
                                setHandlerValidation(handlerElement);
                            });
                    }
                };

                $$epiforms(f).find('.Form__Element').each(function(i, e) {
                    if (this.dataset.fType === 'groupelements') {
                        const elements = $(this).children().children(":not(.formgroupelementscontainerblock)").find(".Form__Element");

                        elements.each(function() {
                            setHandlerByType(this, e);
                        });
                    } else {
                        setHandlerByType(this, e);
                    }
                });

                if ($$epiforms(f).find('[data-f-mainbody]').data("f-stepcount") > 1) {
                    myObj.setUtagMultistep($$epiforms(f).find('[data-f-mainbody]').data("taxon-form-title"),
                        1,
                        $$epiforms(f).find('.progress-bar-percentage-visual').data("progressbar-stepcount"));
                }

                // check if the Next/Previous Ui should be visible at initial load
                if (!($$epiforms(f).find('[data-f-stepindex=0].DisableNextPrevious')[0]) && $$epiforms(f).find('[data-f-mainbody]').data("f-stepcount") > 1) {
                    $$epiforms(f).find('.Form__NextPreviousUi').removeClass("hide");
                }

                $$epiforms(f).on("formsNavigationNextStep formsNavigationPrevStep",
                    function(event) {
                        const progressBarPercentageVisual = document.querySelector('.progress-bar-percentage-visual'),
                            stepcount = progressBarPercentageVisual.getAttribute('data-progressbar-stepcount'),
                            currentStep = event.targetStep.index,
                            progressBarPercentageWidth = 100 * ((currentStep) / (stepcount - 1)) + "%";

                        myObj.setUtagMultistep(event.workingFormInfo.Name, currentStep + 1, stepcount);

                        //progress bar %
                        progressBarPercentageVisual.style.width = progressBarPercentageWidth;
                        //progress bar next
                        let lastStep;

                        if (event.type == "formsNavigationNextStep") {
                            lastStep = currentStep - 1;

                            document.querySelector("[data-progressbar-stepindex='" + currentStep + "']").classList
                                .add("progress-bar-bubble-progress");
                            document.querySelector("[data-progressbar-stepindex='" + currentStep + "']").classList
                                .remove("progress-bar-bubble-incomplete");

                            document.querySelector("[data-progressbar-stepindex='" + lastStep + "']").classList
                                .add("progress-bar-bubble-complete");
                            document.querySelector("[data-progressbar-stepindex='" + lastStep + "']").classList
                                .remove("progress-bar-bubble-progress");

                        }
                        //progress bar prev
                        if (event.type == "formsNavigationPrevStep") {
                            lastStep = currentStep + 1;

                            document.querySelector("[data-progressbar-stepindex='" + currentStep + "']").classList
                                .add("progress-bar-bubble-progress");
                            document.querySelector("[data-progressbar-stepindex='" + currentStep + "']").classList
                                .remove("progress-bar-bubble-complete");

                            document.querySelector("[data-progressbar-stepindex='" + lastStep + "']").classList
                                .add("progress-bar-bubble-incomplete");
                            document.querySelector("[data-progressbar-stepindex='" + lastStep + "']").classList
                                .remove("progress-bar-bubble-progress");

                        }

                        //check if is the first step to change justify class
                        if ((currentStep + 1) == 1) {
                            document.querySelector(".Form__NextPreviousUi").classList.add("justify-content-end");
                            document.querySelector(".Form__NextPreviousUi").classList.remove("justify-content-between");
                        } else {
                            document.querySelector(".Form__NextPreviousUi").classList.add("justify-content-between");
                            document.querySelector(".Form__NextPreviousUi").classList.remove("justify-content-end");
                        }

                        //check if it is the last step so the submit button can be enable
                        if ((currentStep + 1) == stepcount) {
                            document.querySelector(".Form__NextPreviousUi .FormSubmitButton").disabled = false;
                        } else {
                            document.querySelector(".Form__NextPreviousUi .FormSubmitButton").disabled = true;
                        }

                        // check if the Next/Previous Ui should be visible
                        if (!document.querySelector("[data-f-stepindex='" + currentStep + "']").classList
                            .contains("DisableNextPrevious")) {
                            document.querySelector(".Form__NextPreviousUi").classList.remove("hide");
                        } else {
                            document.querySelector(".Form__NextPreviousUi").classList.add("hide");
                        }

                    });

                $$epiforms(f).on("formsStepValidating",
                    function () {
                        validateSubmissionFormats(f);
                    });
            });
        });
    }

    async function initCheck() {
        console.log("Starting $$epiforms Check ", typeof window.$$epiforms);
        const result = await myObj.resolveAfterLoad();
        if (result == "ready") {
            myObj.init();
        }
    }

    myObj.checker = myObj.checker.bind(myObj);
    myObj.init = myObj.init.bind(myObj);
    myObj.resolveAfterLoad = myObj.resolveAfterLoad.bind(myObj);

    initCheck();

    function setHandlerValidation(element) {
        const _utilsSvc = window.epi.EPiServer.Forms.Utils,
            form = _utilsSvc.getWorkingFormFromInnerElement(element),
            formId = _utilsSvc.getFormIdentifier(form),
            field = element.querySelector('[data-f-datainput]');

        if (field) {
            let fieldId,
                fieldName = field.getAttributeNode('name').value,
                fieldValue = typeof field.value === "string" ? field.value : "",
                errorMessage = element.querySelector(`#${fieldName}_desc`),
                formInfo = window.epi.EPiServer.Forms[formId];

            if (field.matches('[type="checkbox"], [type="radio"]')) {
                if (field.matches('[type="checkbox"]')) {
                    const checkboxes = field.closest('div[data-f-element-name]').querySelectorAll('input[type="checkbox"]');
                    let boxChecked = 0;
                    for (const checkbox of checkboxes) {
                        if (checkbox.checked) {
                            boxChecked++;
                        }
                    }
                    if (boxChecked > 0) {
                        fieldValue = "checked";
                    } else {
                        fieldValue = "";
                    }
                }
                if (field.closest('div[data-f-element-name]').hasAttribute('data-guid')) {
                    fieldId = field.closest('div[data-f-element-name]').getAttributeNode('data-guid').value;
                } else {
                    fieldId = field.closest('div[data-f-element-name]').getAttributeNode('id').value;
                }
            } else {
                if (field.hasAttribute('data-guid')) {
                    fieldId = field.getAttributeNode('data-guid').value;
                } else {
                    fieldId = field.getAttributeNode('id').value;
                }
            }

            const validation = window.epi.EPiServer.Forms.Validation;
            const validators = validation.getElementValidators(formInfo.ValidationInfo, fieldId);
            const validated = validation.validateFormValue(fieldName, fieldValue, validators);

            validated.every(function (entry) {
                const currentStepIndex = parseInt(form.find("[name=__FormCurrentStepIndex").val());
                const totalStep = parseInt(form.find("[name=__FormTotalSteps").val());

                if (!myObj.submitted) {

                    if (!entry.isValid) {

                        const messageSanitized = htmlsanitizer.SanitizeHtml(entry.message);

                        errorMessage.classList.remove("hidden");
                        errorMessage.innerHTML = messageSanitized;

                        if (currentStepIndex + 1 === totalStep) {
                            form.find("[data-f-type=submitbutton]").prop("disabled", false);
                        }

                        return false;
                    } else {
                        errorMessage.classList.add("hidden");

                        if (currentStepIndex + 1 === totalStep) {
                            form.find("[data-f-type=submitbutton]").prop("disabled", false);
                        }

                        return true;
                    }
                }

                myObj.submitted = false;
                           
            });
        }
    }

    function validateSubmissionFormats(f) {
        $$epiforms(f).find('.FormAmount__Input').each(function (_i, element) {
            const field = $(element);
            const fieldWithoutFormatting = removeFormatting(field.val());

            field.val(fieldWithoutFormatting);
        });
    }

    function removeFormatting(value) {
        const currentLang = $("input[name=__FormLanguage]").val();

        if (currentLang === "en-CA") {
            value = value.replaceAll(',', '');
        }

        if (currentLang === "fr-CA") {
            value = value.replace(',', '.').replaceAll(/\s/g, '');
        }

        return value.replaceAll('$', '');
    }

    // extend the EpiForm JavaScript API in ViewMode
    if ((typeof epi !== 'undefined') && epi !== null && epi.EPiServer && epi.EPiServer.Forms) {
        $.extend(true,
            epi.EPiServer.Forms,
            {
                // extend the Validator to validate Visitor's value in Clientside.        
                Validators:
                {
                    "www.bdc.ca.Features.Forms.EqualPropertiesFormValidator.EqualPropertiesFormValidator":
                        function (fieldName, fieldValue, validatorMetaData) {
                            // this function is used to validate visitor's data value in ViewMode

                            if (epi.EPiServer.Forms.Utils.getElementValue($("[name='" +
                                validatorMetaData.model.fieldName +
                                "']")) !==
                                fieldValue) {
                                return { isValid: false, message: validatorMetaData.model.message };
                            }

                            return { isValid: true };
                        },
                    "www.bdc.ca.Features.Forms.MinimumNumberValidator.MinimumNumberValidator":
                        function (fieldName, fieldValue, validatorMetaData) {
                            // this function is used to validate visitor's data value in ViewMode

                            fieldValue = removeFormatting(fieldValue);

                            if (parseInt(fieldValue) < parseInt($("[name='" + fieldName + "']").attr("minimumlength"))) {
                                return { isValid: false, message: validatorMetaData.model.message };
                            }

                            return { isValid: true };
                        },
                    "www.bdc.ca.Features.Forms.MaximumNumberValidator.MaximumNumberValidator":
                        function (fieldName, fieldValue, validatorMetaData) {
                            // this function is used to validate visitor's data value in ViewMode

                            fieldValue = removeFormatting(fieldValue);

                            if (parseInt(fieldValue) > parseInt($("[name='" + fieldName + "']").attr("maximumlength"))) {
                                return { isValid: false, message: validatorMetaData.model.message };
                            }

                            return { isValid: true };
                        },
                    "www.bdc.ca.Features.Forms.UrlResponseValidator.UrlResponseValidator":
                        function () {
                            // this function is used to validate visitor's data value in ViewMode
                            return { isValid: true };
                        },
                    "www.bdc.ca.Features.Forms.GroupContainerValidator.GroupContainerValidator":
                        function (fieldName, fieldValue, validatorMetaData) {
                            // this function is used to validate visitor's data value in ViewMode

                            const elements = $("[name='" + validatorMetaData.model.additionalAttributes.ElementName + "']").children(":not(.formgroupelementscontainerblock)").find("input, textarea, select");
                            let valid = false;
                            
                            elements.each(function() {
                                switch ($(this).attr("type")) {
                                    case "checkbox":
                                    case "radio":
                                        if ($(this).is(":checked")) {
                                            valid = true;
                                        }
                                        break;

                                    default:
                                        if ($(this).val().length) {
                                            valid = true;
                                        }

                                }
                            });

                            if (valid) {
                                return { isValid: true };
                            }

                            return { isValid: false, message: validatorMetaData.model.message };
                        }
                }
            });
    }
})();